import { Person } from "./Person";

export interface IMemberFlags {
  enhancePostCompleted: boolean;
  interviewColumnAutomessageSuggestionViewed: boolean;
  hasMutualMatched: boolean;
  searchIconPipelineViewed: boolean;
  suggestedColumnSesionTimes: number;
  suggestedColumnTipDismissed: boolean;
}

export type EvaluatedFeatures = "candidate_suggestions_from_torre" | "meeting_links" | "automessages";

// tslint:disable-next-line interface-over-type-literal
export type ViewedFeatureTrialDialogsFlags = {
  candidate_suggestions_from_torre: string;
  meeting_links: string;
  automessages: string;
};

export interface IMember {
  id?: string;
  subjectId?: number;
  personId?: string;
  name?: string;
  email?: string;
  person?: Person;
  manager: boolean;
  poster: boolean;
  member: boolean;
  status: string;
  visible?: boolean;
  sharingToken?: string;
  flags?: IMemberFlags;
  tsoOperator?: boolean;
  salesOperator?: boolean;
  leader?: boolean;
}

export class Member {

  public static Test(): Member {
    return new Member({
      id: "1",
      person: Person.Test(),
      status: "active",
      manager: false,
      poster: false,
      member: false
    });
  }

  public id?: string;
  public subjectId?: number;
  public personId?: string;
  public name?: string;
  public email?: string;
  public person?: Person;
  public manager: boolean;
  public poster: boolean;
  public member: boolean;
  public status: string;
  public visible?: boolean;
  public sharingToken?: string;
  public flags?: IMemberFlags;
  public tsoOperator?: boolean;
  public salesOperator?: boolean;
  public leader?: boolean;

  constructor(data: IMember) {
    this.id = data.id;
    this.subjectId = data.subjectId;
    this.personId = data.personId;
    this.name = data.name;
    this.email = data.email;
    this.person = data.person ? new Person(data.person) : undefined;
    this.manager = data.manager;
    this.poster = data.poster;
    this.member = data.member;
    this.status = data.status;
    this.visible = data.visible;
    this.sharingToken = data.sharingToken;
    this.flags = data.flags;
    this.leader = data.leader;

    if (!this.subjectId && data.person && data.person.subjectId && data.person.subjectId !== Person.Anonymous().subjectId) {
      this.subjectId = Number(data.person.subjectId);
    } else if (!this.personId && data.person && data.person.id && data.person.id !== Person.Anonymous().id) {
      this.personId = data.person.id;
    } else if (!this.name || !this.email) {
      if (!this.name && data.person && data.person.name && data.person.name !== Person.Anonymous().name) {
        this.name = data.person.name;
      }
      if (!this.email && data.person && data.person.email && data.person.email !== Person.Anonymous().email) {
        this.email = data.person.email;
      }
    }
  }
}
